import { FirebaseError } from "firebase/app";
import { child, get, getDatabase, ref } from "firebase/database";


export const playerAPI = {
    async getSongAPI(artist: string, songTitle: string) {
        try {
            const dbRef = ref(getDatabase());
            const snapshot = await get(child(dbRef, `/${artist}/${songTitle}`))
            const song = await snapshot.val()
            if (!song) throw new FirebaseError('Cannot find this tune, pal...', 'Not Found')
            return song
        } catch (e: any) {
            throw e
        }
    }
}
